import React from "react";
import { TeachingAidOption } from "../../../models/financing-request/teaching-aid-option/TeachingAidOption";
import ElementarySchoolTeachingAidOption from "../../../models/financing-request/teaching-aid-option/ElementarySchoolTeachingAidOption";
import { Grid, FormControlLabel, Switch } from "@material-ui/core";
import { nameof, getSpecialNeedPrice } from "../../../utilities/utilities";
import { SpecialNeedType } from "../../../models/special-need-type/SpecialNeedType";
import Currency from "../../../models/shared/Currency";
import AnnualAdministration from "../../../models/admin/annual-administration/AnnualAdministration";

interface Props {
  teachingAidOption: TeachingAidOption;
  specialNeedType: SpecialNeedType;
  currency: Currency;
  annualPricing: AnnualAdministration;
  onChange: (e: any) => void;
}

export default function ElementaryTeachingAidItem({
  teachingAidOption,
  specialNeedType,
  currency,
  annualPricing,
  onChange
}: Props) {
  let elementarySchoolTeachingAidOption = teachingAidOption as ElementarySchoolTeachingAidOption;

  return (
    <>
      <Grid item lg={3} md={6} sm={12} xs={12}>
        <FormControlLabel
          value={elementarySchoolTeachingAidOption.regular || false}
          checked={elementarySchoolTeachingAidOption.regular || false}
          name={nameof<typeof elementarySchoolTeachingAidOption>("regular")}
          control={<Switch color="secondary" />}
          label={
              getSpecialNeedPrice(currency, specialNeedType, annualPricing)
          }
          labelPlacement="end"
          onChange={onChange}
        />
      </Grid>
    </>
  );
}
